
/* -- THIS IS A GENERATED FILE BY @relay -- */
import { ComponentRegistration } from '@relay/client';

export const registrations: ComponentRegistration[] = [
{
  name: 'AlgoliaSearchResults',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/AlgoliaSearchResults/AlgoliaSearchResults.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GlobalStyles',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/GlobalStyles/GlobalStyles.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NordicFlyer',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/NordicFlyer/NordicFlyer.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Header',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Header/Header.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Footer',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Footer/Footer.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Datasheet',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Datasheet/Datasheet.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Cover',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Cover/Cover.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'SnackbarManager',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Snackbars/SnackbarManager/SnackbarManager.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'TradesProductListing',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/TradesProductListing/TradesProductListing.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ToolFinder',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ToolFinder/ToolFinder.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'TabbedTools',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/TabbedTools/TabbedTools.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TabbedProducts',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/TabbedProducts/TabbedProducts.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SteelStorageConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/SteelStorageConfigurator/SteelStorageConfigurator.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'SearchResults',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/SearchResults/SearchResults.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'REDemptionCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/REDemptionCards/REDemptionCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductRangeRoot',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductRange/ProductRangeRoot.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductListRange',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductListRange/ProductListRange.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductListing',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductListing/ProductListing.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductGallery',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductGallery/ProductGallery.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductDetailPopUp',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductDetailPopUp/ProductDetailPopUp.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LegacyManualsAndSparePartsButton',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductDetailPopUp/LegacyManualsAndSparePartsButton.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductCarousel/ProductCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductCards/ProductCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductAttachmentSelector',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ProductAttachmentSelector/ProductAttachmentSelector.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPEPillarsOfSafety',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/PPEPillarsOfSafety/PPEPillarsOfSafety.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PlatinumServiceSearch',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/PlatinumServiceSearch/PlatinumServiceSearch.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NewProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/NewProductCarousel/NewProductCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NewProductCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/NewProductCards/NewProductCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelProductHero',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MXFuelProductHero/MxFuelProductHero.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelProductDownloads',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MxFuelProductDownloads/MxFuelProductDownloads.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'MxFuelProductComparison',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MxFuelProductComparison/MxFuelProductComparison.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MXCalculator',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/MXCalculator/MXCalculator.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InteractiveRange',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/InteractiveRange/InteractiveRange.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Interactive360Image',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/Interactive360Image/Interactive360Image.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HotspotProductRange',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/HotspotProductRange/HotspotProductRange.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GroupedProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/GroupedProductCarousel/GroupedProductCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeProductCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ForgeProductCards/ForgeProductCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeProductCallouts',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/ForgeProductCallouts/ForgeProductCallouts.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FoamInsertsConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/FoamInsertsConfigurator/FoamInsertsConfigurator.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FeatureProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/FeatureProductCarousel/FeatureProductCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DetailedProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/DetailedProductCarousel/DetailedProductCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DrainCleanersKitBuilder',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/DrainCleanersKitBuilder/DrainCleanersKitBuilder.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AccessorySelector',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/AccessorySelector/AccessorySelector.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'WhatsIncluded',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/WhatsIncluded/WhatsIncluded.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'UnderstandingTheFeatures',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/UnderstandingTheFeatures/UnderstandingTheFeatures.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StoreLocatorCTA',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/StoreLocatorCTA/StoreLocatorCTA.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductToolOverview',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductToolOverview/ProductToolOverview.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductSuggestions',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductSuggestions/ProductSuggestions.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductSpecifications',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductSpecifications/ProductSpecifications.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductReviewsListing',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductReviews/ProductReviewsListing.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductNavigation',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductNavigation/ProductNavigation.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductFeaturesText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductFeaturesText/ProductFeaturesText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductFAQs',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductFAQs/ProductFAQs.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductDetailVideos',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductDetailVideos/ProductDetailVideos.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductDetails',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ProductDetails/ProductDetails.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Hotspot360',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Hotspot360/Hotspot360.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Downloads',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Downloads/Downloads.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'CareIcons',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/CareIcons/CareIcons.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Bolt200ThreeKitConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Bolt200ThreeKitConfigurator/Bolt200ThreeKitConfigurator.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Bolt100ThreeKitConfigurator',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/Bolt100ThreeKitConfigurator/Bolt100ThreeKitConfigurator.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ApplicationGallery',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/ProductDetail/ApplicationGallery/ApplicationGallery.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradesStickyNavigation',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/TradesStickyNavigation/TradesStickyNavigation.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradesAlternateStickyNavigation',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/TradesAlternateStickyNavigation/TradesAlternateStickyNavigation.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StickyNavigation',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/StickyNavigation/StickyNavigation.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InnerNavigation',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Navigation/InnerNavigation/InnerNavigation.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'CookiePopup',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Misc/CookiePopup/CookiePopup.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'YoutubeShortsCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/YoutubeShortsCarousel/YoutubeShortsCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VideoWithText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/VideoWithText/VideoWithText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VideoSeekerCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/VideoSeekerCarousel/VideoSeekerCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VideoCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/VideoCarousel/VideoCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/TradeCards/TradeCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TestimonialSlider',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/TestimonialSlider/TestimonialSlider.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/SystemCards/SystemCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SteelStorageInteractiveVideosWrapper',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/SteelStorageInteractiveVideosWrapper/SteelStorageInteractiveVideosWrapper.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ScrollCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ScrollCarousel/ScrollCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPEJobsite',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/PPEJobsite/PPEJobsite.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MXFuelVideoCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/MXFuelVideoCarousel/MXFuelVideoCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MXFuelSplitVideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/MXFuelSplitVideoBanner/MXFuelSplitVideoBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MultiImageSignpostBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/MultiImageSignpostBanner/MultiImageSignpostBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LightingPreview',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/LightingPreview/LightingPreview.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LaserAnimation',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/LaserAnimation/LaserAnimation.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InteractiveVideo',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/InteractiveVideo/InteractiveVideo.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageSlider',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ImageSlider/ImageSlider.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageGallery',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ImageGallery/ImageGallery.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HotspotCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/HotspotCards/HotspotCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GalleryWithNav',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/GalleryWithNav/GalleryWithNav.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthVideoCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/FullWidthVideoCarousel/FullWidthVideoCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FootwearInteractiveVideo',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/FootwearInteractiveVideo/FootwearInteractiveVideo.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FilteredGallery',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/FilteredGallery/FilteredGallery.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'EventMap',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/EventMap/EventMap.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DrainCleanersApplication',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/DrainCleanersApplication/DrainCleanersApplication.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentVideo',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/ContentVideo/ContentVideo.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CentredCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/CentredCarousel/CentredCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CategoryCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/CategoryCards/CategoryCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CareersMap',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Media/CareersMap/CareersMap.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VirtualTourAccess',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/VirtualTourAccess/VirtualTourAccess.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SignUpStacked',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/SignUpStacked/SignUpStacked.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SignUp',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/SignUp/SignUp.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PromotionSignUpPopUp',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PromotionSignUpPopUp/PromotionSignUpPopUp.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PromotionForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PromotionForm/PromotionForm.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PopupSignUp',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PopupSignUp/PopupSignUp.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PackoutSubmission',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PackoutSubmission/PackoutSubmission.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MasterContactForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/MasterContactForm/MasterContactForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PromotionAddressCollectionForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PromotionAddressCollectionForm/PromotionAddressCollectionForm.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'JSSRegistration',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/JSSRegistration/JSSRegistration.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PreferencesFormSalesforce',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PreferencesFormSalesforce/PreferencesFormSalesforce.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PreferencesFormRoot',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/PreferencesForm/PreferencesFormRoot.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HubRegistration',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/HubRegistration/HubRegistration.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'JSSProductReviews',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/JSSProductReviews/JSSProductReviews.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'EventRegistrationForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/EventRegistrationForm/EventRegistrationForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'EventNDAForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/EventNDAForm/EventNDAForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ConfigurableCompetitionForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/ConfigurableCompetitionForm/ConfigurableCompetitionForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CompetitionForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/CompetitionForm/CompetitionForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'BlitzForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/BlitzForm/BlitzForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'BigRedForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/BigRedForm/BigRedForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AdvancedEventRegistrationForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/AdvancedEventRegistrationForm/AdvancedEventRegistrationForm.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'AccountAreaSignInSignUp',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/AccountAreaSignInSignUp/AccountAreaSignInSignUp.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AccountAreaPasswordResetForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Forms/AccountAreaPasswordResetForm/AccountAreaPasswordResetForm.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PushForPrizesCampaign',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/CompetitionGiveaways/PushForPrizesCampaign/PushForPrizesCampaign.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'WhatsNewBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/WhatsNewBanner/WhatsNewBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/VideoBanner/VideoBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'VerticalCarouselBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/VerticalCarouselBanner/VerticalCarouselBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TwoToneBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TwoToneBanner/TwoToneBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradesInnerBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TradesInnerBanner/TradesInnerBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeHeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TradeHeroBanner/TradeHeroBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TradeBanner/TradeBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StandardsBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/StandardsBanner/StandardsBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TextBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/TextBanner/TextBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SplitContentBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/SplitContentBanner/SplitContentBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SocialLinks',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/SocialLinks/SocialLinks.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SocialBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/SocialBanner/SocialBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Signpost6040',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/Signpost6040/Signpost6040.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ScrollingTextBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/ScrollingTextBanner/ScrollingTextBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'REDemptionBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/REDemptionBanner/REDemptionBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPEBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/PPEBanner/PPEBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PinBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/PinBanner/PinBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ParallaxBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/ParallaxBanner/ParallaxBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PageBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/PageBanner/PageBanner.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'MultiplePinBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/MultiplePinBanner/MultiplePinBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'OutdoorBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/OutdoorBanner/OutdoorBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'M12M18Banner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/M12M18Banner/M12M18Banner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LogoBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LogoBanner/LogoBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LightingBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LightingBanner/LightingBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LeadingBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LeadingBanner/LeadingBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelVideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/MxFuelVideoBanner/MxFuelVideoBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LasersBanner/LasersBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LargeBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/LargeBanner/LargeBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InnerBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/InnerBanner/InnerBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthVideoBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/FullWidthVideoBanner/FullWidthVideoBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputLandingBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/HighOutputLandingBanner/HighOutputLandingBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthBannerWithContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/FullWidthBannerWithContent/FullWidthBannerWithContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FuelBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/FuelBanner/FuelBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'EventDateBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/EventDateBanner/EventDateBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/ContentBanner/ContentBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Banner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/Banner/Banner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AspectRatioBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Banners/AspectRatioBanner/AspectRatioBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ZeroEmissions',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ZeroEmissions/ZeroEmissions.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'WarrantyBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/WarrantyBanner/WarrantyBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'UpcomingEvents',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/UpcomingEvents/UpcomingEvents.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TwoToneContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TwoToneContent/TwoToneContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TwoColumnText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TwoColumnText/TwoColumnText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TripleText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TripleText/TripleText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TripleImageSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TripleImageSplitContent/TripleImageSplitContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeTestimonialCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeTestimonialCarousel/TradeTestimonialCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeDownloadsListing',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeDownloadsListing/TradeDownloadsListing.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeCardListing',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeCardListing/TradeCardListing.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeArticleListingPreview',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeArticleListingPreview/TradeArticleListingPreview.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TradeApplicationProductListingPreview',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TradeApplicationProductListingPreview/TradeApplicationProductListingPreview.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TextWithGallery',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TextWithGallery/TextWithGallery.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TextWithFullWidthImage',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TextWithFullWidthImage/TextWithFullWidthImage.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TabbedCTA',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/TabbedCTA/TabbedCTA.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemsSignposts',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemsSignposts/SystemsSignposts.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemsShowcaseDuo',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemsShowcaseDuo/SystemsShowcaseDuo.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemSelector',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemSelector/SystemSelector.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemsChargerCTA',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemsChargerCTA/SystemsChargerCTA.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SystemFooterBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SystemFooterBanner/SystemFooterBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StoreLocator',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StoreLocator/StoreLocator.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StepByStepContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StepByStepContent/StepByStepContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SteelStorageFeatures',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SteelStorageFeatures/SteelStorageFeatures.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StaticHtml',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StaticHtml/StaticHtml.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StaggeredContentCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/StaggeredContentCarousel/StaggeredContentCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Staggered5050SplitContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Staggered5050SplitContent/Staggered5050SplitContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SplitCTA',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SplitCTA/SplitCTA.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SplitAnchorCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SplitAnchorCards/SplitAnchorCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SimpleCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SimpleCards/SimpleCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SignpostCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/SignpostCarousel/SignpostCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Signpost7030',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Signpost7030/Signpost7030.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Signpost5050',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Signpost5050/Signpost5050.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ServiceCentreLocator',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ServiceCentreLocator/ServiceCentreLocator.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ScrollingCallouts',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ScrollingCallouts/ScrollingCallouts.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RepeatContentScroll',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/RepeatContentScroll/RepeatContentScroll.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductSEOCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductSEOCarousel/ProductSEOCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductLandingProducts',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductLandingProducts/ProductLandingProducts.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductFeatures',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductFeatures/ProductFeatures.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductCarouselWithBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ProductCarouselWithBanner/ProductCarouselWithBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPESupportingContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PPESupportingContent/PPESupportingContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PPESplitContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PPESplitContent/PPESplitContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PneumaticVsCordless',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PneumaticVsCordless/PneumaticVsCordless.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'PageLanguageSelector',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PageLanguageSelector/PageLanguageSelector.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PackoutSignpost',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PackoutSignpost/PackoutSignpost.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'OnlineBlitzSteps',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/OnlineBlitzSteps/OnlineBlitzSteps.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'OneKeySignpost',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/OneKeySignpost/OneKeySignpost.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NumberedCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/NumberedCards/NumberedCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NumberedBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/NumberedBanner/NumberedBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Newsletter',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Newsletter/Newsletter.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NailersFeatures',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/NailersFeatures/NailersFeatures.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelZeroEmissions',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelZeroEmissions/MxFuelZeroEmissions.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelIcons',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelIcons/MxFuelIcons.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelHoverProduct',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelHoverProduct/MxFuelHoverProduct.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelBenefits',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelBenefits/MxFuelBenefits.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MxFuelAnimatedScroll',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MxFuelAnimatedScroll/MxFuelAnimatedScroll.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MX4HotspotComparison',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/MX4HotspotComparison/MX4HotspotComparison.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'M18FuelBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/M18FuelBanner/M18FuelBanner.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LightingContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LightingContent/LightingContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LayeredDualImageBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LayeredDualImageBanner/LayeredDualImageBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersTabbedOverview',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersTabbedOverview/LasersTabbedOverview.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersRange',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersRange/LasersRange.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersPreviewVideos',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersPreviewVideos/LasersPreviewVideos.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersOverviewIcons',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersOverviewIcons/LasersOverviewIcons.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersIntroduction',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersIntroduction/LasersIntroduction.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersDemoCta',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersDemoCta/LasersDemoCta.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersComparisonVideo',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/LasersComparisonVideo/LasersComparisonVideo.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'KeyFeaturesShowcase',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/KeyFeaturesShowcase/KeyFeaturesShowcase.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IntroductionText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/IntroductionText/IntroductionText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageWithBorder',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ImageWithBorder/ImageWithBorder.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ImageGrid',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ImageGrid/ImageGrid.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IconWithText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/IconWithText/IconWithText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IconBar',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/IconBar/IconBar.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HtmlContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HtmlContent/HtmlContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighOutputSplitContent/HighOutputSplitContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputLetterboxSection',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighOutputLetterboxSection/HighOutputLetterboxSection.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighOutputGraphs',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighOutputGraphs/HighOutputGraphs.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HighlightedFeaturesProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HighlightedFeaturesProductCarousel/HighlightedFeaturesProductCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HeatedGearTabbed',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HeatedGearTabbed/HeatedGearTabbed.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HeatedGearIcon',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HeatedGearIcon/HeatedGearIcon.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HandtoolsGuarantee',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/HandtoolsGuarantee/HandtoolsGuarantee.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GuaranteeSplitDetailCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/GuaranteeSplitDetailCards/GuaranteeSplitDetailCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GenericImageText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/GenericImageText/GenericImageText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FullWidthText/FullWidthText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthImageFeature',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FullWidthImageFeature/FullWidthImageFeature.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthContentCTA',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FullWidthContentCTA/FullWidthContentCTA.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeWalkaround',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeWalkaround/ForgeWalkaround.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeTabbedProductCarousel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeTabbedProductCarousel/ForgeTabbedProductCarousel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeSizeCalloutScrollJack',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeSizeCallout/ForgeSizeCalloutScrollJack.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeSizeCallout',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeSizeCallout/ForgeSizeCallout.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeSignpost',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeSignpost/ForgeSignpost.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeRuntimeCallouts',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeRuntimeCallouts/ForgeRuntimeCallouts.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgePowerScale',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgePowerScale/ForgePowerScale.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeMXFuelBanner',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeMXFuelBanner/ForgeMXFuelBanner.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeCooling',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeCooling/ForgeCooling.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeCoolCycleFlow',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeCoolCycleFlow/ForgeCoolCycleFlow.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeChargeComparisonTable',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeChargeComparisonTable/ForgeChargeComparisonTable.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeChargeCallouts',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeChargeCallouts/ForgeChargeCallouts.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ForgeCellTechnologies',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ForgeCellTechnologies/ForgeCellTechnologies.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FiftyFiftyDetailedContentAccordion',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FiftyFiftyDetailedContentAccordion/FiftyFiftyDetailedContentAccordion.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FeaturedPanel',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FeaturedPanel/FeaturedPanel.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FAQList',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/FAQList/FAQList.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ExtendedText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ExtendedText/ExtendedText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DualProductCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DualProductCards/DualProductCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DualImageAndText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DualImageAndText/DualImageAndText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DrainCleanersSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DrainCleanersSplitContent/DrainCleanersSplitContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DownloadListing',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DownloadListing/DownloadListing.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DownloadCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DownloadCards/DownloadCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'DetailedCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/DetailedCards/DetailedCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CtaImageGrid',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CtaImageGrid/CtaImageGrid.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CTA',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CTA/CTA.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CountdownTimer',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CountdownTimer/CountdownTimer.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContentGeneral',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ContentGeneral/ContentGeneral.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ColourRenderingContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ColourRenderingContent/ColourRenderingContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ChargeTimeTable',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ChargeTimeTable/ChargeTimeTable.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ChargeTimeRange',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/ChargeTimeRange/ChargeTimeRange.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CentreText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CentreText/CentreText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CategoryListing',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CategoryListing/CategoryListing.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CarouselCardsWithText',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CarouselCardsWithText/CarouselCardsWithText.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CareersSplitContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CareersSplitContent/CareersSplitContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CalloutCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/CalloutCards/CalloutCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Callout5050',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Callout5050/Callout5050.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'BatteryTypeCards',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/BatteryTypeCards/BatteryTypeCards.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AuthorisedDistributor',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/AuthorisedDistributor/AuthorisedDistributor.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AccountAreaRoot',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/AccountArea/AccountAreaRoot.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Accordion',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Accordion/Accordion.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AboutUsTimeline',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/AboutUsTimeline/AboutUsTimeline.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AboutUsCallout',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/AboutUsCallout/AboutUsCallout.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TeesterTracking',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/TeesterTracking/TeesterTracking.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ScrollToTop',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/ScrollToTop/ScrollToTop.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ParamsAnchor',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/ParamsAnchor/ParamsAnchor.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Loader',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Elements/Misc/Loader/Loader.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'NavigationTypeahead',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Components/Search/NavigationTypeahead/NavigationTypeahead.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ProductList',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Components/Products/ProductList/ProductList.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ProductFinder',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Components/Products/ProductFinder/ProductFinder.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LasersPopupForm',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Components/Forms/LasersPopupForm/LasersPopupForm.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'GenericPopup',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Components/Content/GenericPopup/GenericPopup.hybrid'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LightingCalculatorWidget',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Products/LightingCalculator/LightingCalculatorWidget/LightingCalculatorWidget.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StandardsContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/StandardsContent/StandardsContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SafetyGlassesContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/SafetyGlassesContent/SafetyGlassesContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RespiratorsContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/RespiratorsContent/RespiratorsContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'KneePadsContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/KneePadsContent/KneePadsContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HearingProtectionContent',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/Standards/HearingProtectionContent/HearingProtectionContent.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PressReleaseListingRoot',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PressRelease/PressReleaseListing/PressReleaseListingRoot.hybrid'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PressReleaseDetail',
  import: (): Promise<any> => import('C:/agent/_work/10964/s/CMS/SiteFiles/next-gen/src/stories/Widgets/Content/PressRelease/PressReleaseDetail/PressReleaseDetail.hybrid'),
  config: {
    hydrate: 'in-view',
  },
} 
];
  